import styled from 'styled-components';

const DesktopLayoutWrapper = styled.div`
  .app-container {
    display: grid;
    grid-template-rows: 64px 1fr;
    grid-template-columns: 61px 1fr;
  }
  .app-header {
    grid-row: 1/2;
    grid-column: 2/3;
  }

  .left-nav-wrapper {
    grid-row: 1/3;
    grid-column: 1/2;
  }
`;

export { DesktopLayoutWrapper };
